import {BaseModel} from '../../base/models/base-model.model';
import {ModelDate} from '../../shared/DTO/modelDate';
import {ListString} from '../../shared/DTO/listString';
import {IdCardType} from '../../shared/DTO/idCardType';

export class IdCardModel extends BaseModel {
  private _city?: string;
  private _country?: string;
  private _expirationDate?: ModelDate;
  private _files?: ListString;
  private _releaseBy?: string;
  private _releaseDate?: ModelDate;
  private _state?: string;
  private _type?: IdCardType;

  constructor(city?: string, country?: string, expirationDate?: ModelDate, files?: ListString, id?: string, releaseBy?: string, releaseDate?: ModelDate, state?: string, type?: IdCardType) {
    super();
    this._city = city;
    this._country = country;
    this._expirationDate = expirationDate;
    this._files = files;
    this._id = id;
    this._releaseBy = releaseBy;
    this._releaseDate = releaseDate;
    this._state = state;
    this._type = type;
  }

  get city(): string {
    return this._city;
  }

  set city(value: string) {
    this._city = value;
  }

  get country(): string {
    return this._country;
  }

  set country(value: string) {
    this._country = value;
  }

  get expirationDate(): ModelDate {
    return this._expirationDate;
  }

  set expirationDate(value: ModelDate) {
    this._expirationDate = value;
  }

  get files(): ListString {
    return this._files;
  }

  set files(value: ListString) {
    this._files = value;
  }

  get id(): string {
    return this._id;
  }

  set id(value: string) {
    this._id = value;
  }

  get releaseBy(): string {
    return this._releaseBy;
  }

  set releaseBy(value: string) {
    this._releaseBy = value;
  }

  get releaseDate(): ModelDate {
    return this._releaseDate;
  }

  set releaseDate(value: ModelDate) {
    this._releaseDate = value;
  }

  get state(): string {
    return this._state;
  }

  set state(value: string) {
    this._state = value;
  }

  get type(): IdCardType {
    return this._type;
  }

  set type(value: IdCardType) {
    this._type = value;
  }
}
